import React from "react";
import { Grid, Paper, Typography, Container, Avatar, makeStyles, Theme } from "@material-ui/core";
import { Link } from "gatsby";
import { basePath } from "../common/consts";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useAnalyticsEvents } from "../analytics/events.home";
const SectionItem = ({ item, lang }) => {
  const classes = useStyles()
  const { clickSectionEvent } = useAnalyticsEvents()

  const handleClick = async () => {
    clickSectionEvent(lang, item?.prismicId, item?.data?.title?.text)
  }

  return (
    <Grid item className={classes.gridRoot} onClick={handleClick} >
      <Paper>
        <Link to={`${basePath}${item?.lang}/section/${item?.prismicId}`}  >
          {(
            <Grid item xs={12} container direction="row" className={classes.gridRow}>

              <Grid item xs={2} container justifyContent="center" alignItems="center" >
                <Avatar src={item?.data?.icon?.url} variant="square" className={classes.icon} />
              </Grid>

              <Grid item xs={9} container direction="column" style={{}}>
                <Typography variant="body1" className={classes.heading} >{item?.data?.title?.text}</Typography>
                <Typography variant="body2" color="textSecondary" style={{}} >
                  {item?.data?.description?.text}
                </Typography>
              </Grid>

              <Grid item xs={1} container justifyContent="center" alignItems="center" >
                <ChevronRightIcon color="primary" />
              </Grid>

            </Grid>
          )}
        </Link>
      </Paper>
    </Grid>
  );
}

export default SectionItem

const useStyles = makeStyles((theme: Theme) => ({
  gridRoot: {
    margin: "0 0 8px 0"
  },
  gridRow: {
    padding: "16px 4px"
  },
  icon: {
    height: "28px", width: "28px"
  },
  heading: {
    fontWeight: "bold"
  }

}));